<template>
  <!-- <div class="frame" ref="model" :style="{top: `${offset.top}px`, left: `${offset.left}px`}" > -->
  <div class="model-main">
    <div ref="model" class="frame">
      <div class="frame-head" @mousedown="mousedown" @mousemove="mousemove" @mouseup="mouseup" @mouseleave="mouseleave">
        <img src="../../../assets/img/client/chat/LOGO／黑@2x(1).png" width="128px" height="30px">
        <img src="../../../assets/img/client/chat/close.png" width="16px" height="16px" @click="closeChat">
      </div>
      <div class="frame-info">
        <slot name="info" />
      </div>
      <div class="frame-btn">
        <slot name="btn" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustModel',
  data() {
    return {
      moveFlag: false,
      showModel: false,
      image: '',
      offset: {
        x: 0,
        y: 0,
        left: 0,
        top: 0
      }
    }
  },
  methods: {
    clickClose() {
      this.showModel = false
      this.offset = {
        x: 0,
        y: 0,
        left: 0,
        top: 0
      }
    },
    openModel() {
      this.showModel = true
    },
    mousedown(e) {
      this.moveFlag = true
      // this.offset.x = e.pageX - this.$refs.model.offsetLeft;
      // this.offset.y = e.pageY - this.$refs.model.offsetTop;
    },
    mousemove(e) {
      if (this.moveFlag) {
        // this.offset.top = e.pageY - this.offset.y;
        // this.offset.left = e.pageX - this.offset.x;
      }
    },
    mouseleave() {
      this.moveFlag = false
    },
    mouseup() {
      this.moveFlag = false
    },
    closeChat() {
      this.$emit('close')
    }

  }
}
</script>

<style lang="scss" scoped>
.model-main{
    position: fixed;
    background: rgba(0, 0, 0, 0.4);
    z-index: 100;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;
    .frame {
        width: 970px;
        height: auto;
        position: relative;
        margin: 0 auto 50px;
        background: #fff;
        margin-top: 15vh;
        -webkit-box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
        border-radius: 16px;
        .frame-head {
            height: 64px;
            background:  #F8CFB9;
            border-radius: 16px 16px 0px 0px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 922px;
            display: flex;
            padding: 0 24px;
            .title {
                font-weight: bold;
            }
            div {
                height: 100%;
            }
            .close {
                font-size: 20px;
                font-weight: bold;
                cursor: default;
            }
        }
        .frame-info {
            width: 970px;
            height: 480px;
            background: #EDEEF0;
			overflow: auto;
        }
        .frame-btn {
            width: 970px;
            height: 136px;
            background: rgba(255,255,255,0);
            border-radius: 0px 0px 16px 16px;
        }
    }
}
</style>
